<template>
  <!-- 添加物模型 -->
  <div class="">
    <v-dialog
      class="popbox"
      name="dialog2"
      v-model="isShow"
      :title="dialogTitle"
      close-on-click-modal
      :modal="true"
      :width="1000"
      @open="open"
      @after-close="handleAfterClose"
      @confirm="handleConfirm"
      append-to-body
    >
      <div>
        <div class="search-box">
          <v-select
            isClear
            class="mr10"
            v-model="function_type"
            placeholder="请选择功能类型"
            :options="functionTypeOptions"
            @change="typeChange"
          ></v-select>
          <v-select
            isClear
            isSearch
            class="mr10"
            v-model="name"
            placeholder="请选择功能名称"
            :options="nameOptions"
            @change="nameChange"
          ></v-select>
          <v-select
            isClear
            isSearch
            class="mr10"
            v-model="identifier"
            placeholder="请选择标识符"
            :options="identifierOptions"
            @change="identifierChange"
          ></v-select>
          <!-- <v-button type="primary" @click="onSearch">查找</v-button> -->
          <!-- <v-button type="default" @click="onRest">重置</v-button> -->
        </div>
        <vxe-table
          row-id="ID"
          :data="tableData"
          :row-config="{ isCurrent: true, isHover: true }"
          :radio-config="{ trigger: 'row' }"
          @radio-change="radioChangeEvent"
          align="left"
          :sort-config="{ defaultSort: { field: 'function_typeView', order: 'asc' } }"
        >
          <vxe-table-column type="radio" width="60" title="#"></vxe-table-column>
          <vxe-table-column field="name" show-overflow min-width="80" title="功能名称"></vxe-table-column>
          <vxe-column title="功能类型" field="function_typeView" sortable show-overflow min-width="80">
            <template v-slot="slotProps">
              <span v-if="slotProps.row.function_typeView === '事件'" class="text-success">{{ slotProps.row.function_typeView }}</span>
              <span v-if="slotProps.row.function_typeView === '属性'" class="text-error">{{ slotProps.row.function_typeView }}</span>
              <span v-if="slotProps.row.function_typeView === '服务'" class="text-warn">{{ slotProps.row.function_typeView }}</span>
            </template>
          </vxe-column>
          <vxe-table-column field="identifier" show-overflow min-width="100" title="功能唯一标识"></vxe-table-column>
          <vxe-table-column field="data_type" show-overflow min-width="80" title="数据类型"></vxe-table-column>
          <vxe-column field="model_type" show-overflow min-width="80" title="物模型类型">
            <template v-slot="slotProps">
              <span v-if="slotProps.row.model_type === 'COMMON'" class="text-success">公共物模型</span>
              <span v-if="slotProps.row.model_type === 'PRODUCT'" class="text-warn">产品物模型</span>
            </template>
          </vxe-column>
          <vxe-table-column field="desc" show-overflow min-width="280" title="备注"></vxe-table-column>
        </vxe-table>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import { FUNCTION_TYPE } from "@/common/libs/Contains";
export default {
  components: {},
  props: {
    showInputDialog: {
      type: Boolean,
      default: false,
    },
    productKey: {},
    productId: {},
  },
  data() {
    return {
      FUNCTION_TYPE,
      isShow: false,
      dialogTitle: "添加公共功能",
      functionTypeOptions: [
        {
          label: "全部",
          value: "all",
        },
        {
          label: "属性",
          value: "properties",
        },
        {
          label: "服务",
          value: "service",
        },
        {
          label: "事件",
          value: "event",
        },
      ],
      function_type: "all",
      name: "",
      identifier: "",
      nameOptions: [],
      identifierOptions: [],
      tableData: [],
      checkRaw: {},
    };
  },
  created() {},
  watch: {
    showInputDialog(newVal) {
      this.isShow = newVal;
      newVal && this.init();
    },
  },
  methods: {
    open() {},
    init() {
      this.getCommonList({}, (res) => {
        const _nameOptions = [];
        const _identifierOptions = [];
        const _tableData = [];
        (res.data || []).map((item) => {
          _nameOptions.push({ label: item.name, value: item.name });
          _identifierOptions.push({ label: item.identifier, value: item.identifier });
          _tableData.push({ ...item, function_typeView: FUNCTION_TYPE[item.function_type] });
        });
        this.nameOptions = [..._nameOptions];
        this.identifierOptions = [..._identifierOptions];
        this.tableData = _tableData;
      });
    },
    getCommonList(data, callback) {
      data.function_type = data.function_type == 'all' ? '' : data.function_type
      this.$post("/td/td-iot-api/iot/thing/common/list/v1", data, false).then((res) => {
        let code = +res.code;
        if (code === 0) {
          callback(res);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    typeChange(value) {
      console.log(value)
      this.function_type = value;
      this.onSearch();
    },
    nameChange(value) {
      this.name = value;
      this.onSearch();
    },
    identifierChange(value) {
      this.identifier = value;
      this.onSearch();
    },
    onSearch() {
      const submitData = {
        function_type: this.function_type,
        name: this.name,
        identifier: this.identifier,
      };
      this.getCommonList(submitData, (res) => {
        this.tableData = (res.data || []).map((item) => {
          return { ...item, function_typeView: FUNCTION_TYPE[item.function_type] };
        });
      });
    },
    // onRest() {
    //   this.identifier = "";
    //   this.name = "";
    //   this.function_type = "";
    //   this.init();
    // },
    radioChangeEvent(data) {
      this.checkRaw = { ...data.row };
    },
    handleConfirm() {
      let submitData = { ...this.checkRaw };
      submitData.product_id = Number(this.productId);
      submitData.product_key = this.productKey;
      submitData.model_type = "COMMON";
      this.$post("/td/td-iot-api/iot/thing/draft/v1", submitData, false).then((res) => {
        let code = +res.code;
        if (code === 0) {
          this.$emit("getData");
          this.$message.success(res.msg);
        } else {
          this.$message.error(res.msg);
        }
      });
      this.$emit("update:showInputDialog", false);
      Object.assign(this.$data, this.$options.data());
    },
    handleAfterClose() {
      this.$emit("update:showInputDialog", false);
      Object.assign(this.$data, this.$options.data());
    },
  },
  beforeDestroy() {},
};
</script>

<style lang="less" scoped>
.search-box {
  margin-bottom: 16px;
  display: flex;
  justify-content: flex-end;
}
::v-deep {
  .v-dialog__main {
    max-height: none !important;
  }
  .vxe-table--body-wrapper {
    max-height: 360px !important;
  }
}
</style>
